import { render, staticRenderFns } from "./OverviewSublet.vue?vue&type=template&id=4c60a8be&scoped=true"
import script from "./OverviewSublet.vue?vue&type=script&lang=js"
export * from "./OverviewSublet.vue?vue&type=script&lang=js"
import style0 from "./OverviewSublet.vue?vue&type=style&index=0&id=4c60a8be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c60a8be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c60a8be')) {
      api.createRecord('4c60a8be', component.options)
    } else {
      api.reload('4c60a8be', component.options)
    }
    module.hot.accept("./OverviewSublet.vue?vue&type=template&id=4c60a8be&scoped=true", function () {
      api.rerender('4c60a8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/components/OverviewSublet.vue"
export default component.exports